import ApplicationController from './application_controller'
import { useSpreedly } from './mixins/useSpreedly'

export default class extends ApplicationController {
  static targets = ['submitButton', 'termsAndConditionsInput']

  connect() {
    super.connect()
    useSpreedly(this)
    this.initSpreedly()
  }

  async submitForm(event) {
    event.preventDefault()
    event.stopPropagation()

    const valid = await this.validateForm()
    if (!valid) return

    this.submitSpreedly()
  }

  async validateForm() {
    try {
      const spreedlyForm = this.spreedlyPaymentForm()
      const formData = new FormData(spreedlyForm)
      formData.append('validate_only', 'true')

      const response = await fetch(spreedlyForm.action, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'application/json'
        },
        body: formData
      })

      const { valid, errors } = await response.json()

      if (!valid) {
        this.renderErrors(errors.map(message => ({ message })))
      }

      return valid
    } catch {
      this.renderErrors([{ message: "There was an error processing your request. Please try again." }])
      return false
    }
  }

  togglePreauthorization(event) {
    let terms = (event.target.value === 'true') ? I18n.payment_sources.pre_auth_terms_and_conditions_html : I18n.payment_sources.terms_and_conditions_html
    let parser = new DOMParser()
    let html_terms = parser.parseFromString(terms, 'text/html').body.childNodes
    let checkbox = this.termsAndConditionsInputTarget.parentElement.firstElementChild
    this.termsAndConditionsInputTarget.parentElement.replaceChildren(checkbox, ...html_terms)
    this.termsAndConditionsInputTarget.checked = false
  }
}
